/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {CountryCode} from "./countryCode.zod";

export const CheckLeadSimilarityRequest = zod.object({
  companyName: zod.string().min(1),
  countryCode: CountryCode,
  websiteUrl: zod.string().nullish().describe("Optional absolute HTTP(S) URL with a host."),
});

export type CheckLeadSimilarityRequest = zod.input<typeof CheckLeadSimilarityRequest>;
export type CheckLeadSimilarityRequestOutput = zod.output<typeof CheckLeadSimilarityRequest>;
